<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12 col-md-6 col-lg-6">
        <span class="h2 e-text-red text-uppercase font-weight-bold">VESSEL LIST</span>
      </div>
      <div class="col-sm-12 col-md-2 col-lg-2 d-flex justify-content-center align-items-center pr-2">
        <select name="" id="" class="form-control form-control-sm" v-model="params.active">
          <option value="" disabled>SELECT STATUS</option>
          <option :value="null">ALL</option>
          <option :value="1" class="bg-light">ACTIVE</option>
          <option :value="0" class="bg-light">INACTIVE</option>
        </select>
      </div>
      <div class="col-sm-12 col-md-4 col-lg-4 d-flex justify-content-center align-items-center pl-0">
        <input type="text" name="vesselSearch" class="form-control form-control-sm" v-model="params.search" placeholder="Search Vessel">
      </div>
    </div>
    <hr style="border-top: 3px solid #e1e1e1">
    <div class="row">
      <div class="col-sm-12 col-md-8 col-lg-8">
        <nav aria-label="...">
          <ul class="pagination text-smallest mb-0 pb-0">
            <li class="page-item" :class="{ 'disabled': pagination.currentPage === 1}">
              <button class="page-link" @click="setVesselsToTable(1)">First</button>
            </li>

            <li v-for="page in paginationPages" :key="page" class="page-item" :class="{ 'disabled': page === '...', 'active': page === pagination.currentPage }">
              <button class="page-link" @click="setVesselsToTable(page)">{{ page }}</button>
            </li>

            <li class="page-item" :class="{ 'disabled': pagination.currentPage === pagination.lastPage}">
              <button class="page-link" @click="setVesselsToTable(pagination.lastPage)">Last</button>
            </li>
          </ul>
        </nav>
      </div>
      <div class="col-sm-12 col-md-4 col-lg-4 d-flex justify-content-end align-items-center">
        <button v-if="isAllowed('vessels.create')" @click="$router.push({name:'VesselAdd'})" class="e-btn e-btn-green text-uppercase font-weight-bold mr-1 e-text-white">
          <font-awesome-icon icon="plus-square" class="mr-1"/>
          New Vessel
        </button>
        <template v-if="['k-line-persons', 'k-line-persons2'].includes(user.roles_permissions?.roles[0]) === false">

          <div class="float-right dropdown dropright" v-if="vesselList.length">
            <button id="downloadVesselDropdown"
                    aria-expanded="false"
                    aria-haspopup="true"
                    class="mr-2 e-btn e-btn-blue force-white-all"
                    data-toggle="dropdown"
                    :disabled="loading" :class="loading ? 'e-btn-blue-gray cursor-not-allowed' : 'e-btn-primary'"
            >
              <font-awesome-icon class="mr-1" icon="download"/>
              DOWNLOAD LIST
            </button>
            <div aria-labelledby="downloadVesselDropdown" class="dropdown-menu">
              <button class="dropdown-item text-secondary font-weight-bolder"
                      type="button"
                      @click="exportToExcel('xlsx')">
                <font-awesome-icon icon="file-excel"/>
                Excel (XLSX)
              </button>
              <button class="dropdown-item text-secondary font-weight-bolder"
                      type="button"
                      @click="exportToExcel('csv')">
                <font-awesome-icon icon="file-pdf"/>
                CSV
              </button>
            </div>
          </div>
          <button class="e-btn e-btn-blue-gray cursor-not-allowed text-uppercase font-weight-bold e-text-white" v-else-if="!vesselList.length">
            <font-awesome-icon icon="download" class="mr-1"/>
            DOWNLOAD LIST
          </button>
        </template>

      </div>
    </div>
    <div class="row mt-2">
      <div class="col-12">
        <div style="height: 74.5vh; overflow-y: auto">
          <div class="card">
            <div class="card-body p-0" >
              <table class="table table-bordered mb-0">
                <thead style="position: sticky; top: 0; z-index: 2">
                <tr style="box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);">
                  <th class="text-center text-uppercase bg-f3f3f3 p-2" style="width: 1em" scope="col">#</th>
                  <th class="text-center text-uppercase bg-f3f3f3 p-2">Ship Name</th>
                  <th class="text-center text-uppercase bg-f3f3f3 p-2">Flag</th>
                  <th class="text-center text-uppercase bg-f3f3f3 p-2">Ship Type</th>
                  <th class="text-center text-uppercase bg-f3f3f3 p-2">Management</th>
                  <th class="text-center text-uppercase bg-f3f3f3 p-2">Fleet</th>
                  <th class="text-center text-uppercase bg-f3f3f3 p-2" style="width: 5em" scope="col">Status</th>
                  <th class="text-center text-uppercase bg-f3f3f3 p-2" style="width: 50px" scope="col">Action</th>
                </tr>
                </thead>
                <tbody>
                <template v-if="loading">
                  <tr>
                    <td colspan="100%">
                      <app-loading></app-loading>
                    </td>
                  </tr>
                </template>
                <template v-else-if="!loading && !vesselList.length">
                  <tr>
                    <td colspan="100%">
                      <div class="p-4 text-center">
                        <h4 class="font-weight-bold text-uppercase" style="color: black">No Data Found</h4>
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <tr v-for="(vessel, index) in vesselList" :key="vessel.id">
                    <td class="align-middle text-center text-uppercase">{{ index + pagination.from }}</td>
                    <td class="align-middle text-center text-uppercase">{{ vessel.name }}</td>
                    <td class="align-middle text-center text-uppercase">{{ vessel.flag ? vessel.flag.name : '' }}</td>
                    <td class="align-middle text-center text-uppercase">{{ vessel.vessel_type ? vessel.vessel_type.name : '' }}</td>
                    <td class="align-middle text-center text-uppercase">{{ vessel.management_company ? vessel.management_company.name : '' }}</td>
                    <td class="align-middle text-center text-uppercase">{{ vessel.fleet ? vessel.fleet.name : '' }}</td>
                    <td class="align-middle text-center">
                      {{ vessel.active == 1 ? 'ACTIVE' : 'INACTIVE' }}
                    </td>
                    <td class="align-middle text-center py-1">
                      <div class="dropdown dropright" v-if="isElite() || isAllowed('vessels.delete') || isOwnVessel(vessel.id)">
                        <button
                          id="actionDropdown"
                          aria-expanded="false"
                          aria-haspopup="true"
                          class="btn btn-sm btn-secondary force-white-all"
                          data-toggle="dropdown"
                        >
                          <font-awesome-icon icon="cogs"/>
                        </button>
                        <div aria-labelledby="actionDropdown" class="dropdown-menu py-0">
                          <button class="dropdown-item text-secondary font-weight-bolder"
                                  @click="vesselOverview(vessel.id)">
                            <font-awesome-icon icon="eye"/>
                            View
                          </button>
                          <button class="dropdown-item text-secondary font-weight-bolder"
                                  @click="showVesselOverviewNewTab(vessel.id)"
                          >
                            <font-awesome-icon icon="share"/>
                            View on New Tab

                          </button>
                          <button class="dropdown-item text-secondary font-weight-bolder text-danger"
                                  @click="deleteSelected(vessel.id)"
                                  v-if="isAllowed('vessels.delete')"
                          >
                            <font-awesome-icon icon="trash" class="e-text-red"/>
                            Delete
                          </button>
                        </div>
                      </div>
                      <button class="e-btn e-btn-blue e-btn-sm e-text-white"
                              @click="vesselOverview(vessel.id)" v-else>
                        <font-awesome-icon icon="eye" />
                        View
                      </button>
                    </td>
                  </tr>
                </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {vueAppMixin} from "@/mixins/vueAppMixin";
import AppLoading from "@/components/elements/AppLoading";

import _ from 'lodash';
import {permissionMixin} from "@/mixins/permissionMixins";
import {AlertService} from "@/services/AlertService";
import {PaginationMixin} from "@/mixins/PaginationMixin";
import vessel from "@/views/Vessel.vue";
import {VesselService} from "@/services/VesselService";

export default {

  mixins: [vueAppMixin,permissionMixin,PaginationMixin],
  components: {AppLoading},

  name: 'VesselIndex',
  data() {
    return {
      params: {
        active: 1,
        page:1,
        search:'',
        selectedExportType: ''
      },
      loading: false,
    }
  },
  methods: {
    ...mapActions([
      'getVessels',
      'deleteVessel'
    ]),
    // todo
    async vesselOverview(vesselId) {
      // await this.$router.push({ name: 'VesselShow', params: { id: vesselId } }).catch(() => {})
      await this.$router.push({
        name: "VesselParticular",
        params: {id: vesselId},
      });

    },
    async showVesselOverviewNewTab(vesselId) {
      const route = this.$router.resolve(
        {
          name: 'VesselParticular',
          params: {
            id: vesselId,
          },
        },
      )
      window.open(route.href,'_blank')
    },
    async deleteSelected(vesselId){
      if(await AlertService.confirmDeleteAlert('Delete VESSEL Record', 'Are you sure you want to delete this Vessel Record?', 'Delete')){
        swal.fire({
          title:'ENTER YOUR PASSWORD',
          input: 'password',
          inputAttributes: {
            autocapitalize: 'off'
          },
          confirmButtonText:'PROCEED DELETION',
          cancelButtonText: 'CANCEL',
          showCancelButton:true,
          allowOutsideClick:false,
          allowEscapeKey:false,
          allowEnterKey:false,
          confirmButtonColor:'#dc3545',
          showLoaderOnConfirm:true,
          preConfirm:async (password)=> {
            let response = await this.deleteVessel({vesselId, password})


            if (typeof response === 'boolean' && response) {
              return response;
            } else {
              if (response.hasOwnProperty('message') && !response.hasOwnProperty('errors')) {
                swal.showValidationMessage(response.message);
              }
              else{
                swal.showValidationMessage(response.errors?.password.join(','));
              }
            }
          }
        })
        .then(async (result)=>{
          if(result.isConfirmed){
            await this.successAlert('VESSEL RECORD DELETED SUCCESSFULLY','DELETE VESSEL RECORD');
            await this.setVesselsToTable();
          }
        });
      }
    },
    async setVesselsToTable(page=1) {
      this.loading = true;
      this.params.page=page
      await this.getVessels(this.params)
      this.loading = false;
    },
    async exportToExcel(type){
      this.params.selectedExportType = type;
      swal.fire({
        'title': `LOADING...`,
        text: 'Please wait while the system exports the data.',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      })
      swal.showLoading()
      const downloadResponse = await VesselService.downloadVesselList(this.params);
      swal.close()
      let url = window.URL.createObjectURL(new Blob([downloadResponse.data],{type:'application/vnd.ms-excel'}))
      const date = new Date().toISOString().split("T")[0];
      let filename=`Vessel_List_${date}.${type}`;
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    },
  },
  computed: {
    ...mapGetters(['pagination',
    'vesselList',
      'isLoading',

    ])
  },
  async created() {
    this.setVessels = _.debounce(this.setVesselsToTable, 750)
    await this.setVesselsToTable();
  },
  watch: {
    'params.active'() {
      this.setVessels()
    },
    'params.search'(){
      this.setVessels();
    }
  },

  destroyed() {
    this.params.active = 1;
  }

}
</script>

<style scoped lang="scss">
  .bg-f3f3f3{
    background: #e9e9e9;
    border: 2px solid #e1e1e1;
    color: black;
  }
</style>
